export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/lofi.07db0de.svg";